<template>
  <div class="animated fadeIn">
    <GeneralSpinner v-if="spinner_message"></GeneralSpinner>
    <div class="page-card-margin row" v-else="">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong><i class="fa fa-bell-o"></i> {{web_texts.messages}}</strong>
          </div>
          <div class="card-block">
            <vue-good-table :columns="columns" :rows="messages" :paginate="true" :perPage="10"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Messages';
  import trans_es from '../translates/es/Messages';
  import constants from '../constants'
  import middleware from '../utilities/middlewares'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: 'Messages',
    data() {
      return {
        web_texts: {"messages": "Missatges"},
        messages: [],
        spinner_message:true,
        columns: [
          {
            label: 'Data',
            field: 'date',
            width: '115px',
            html: true
          },
          {
            label: 'Text',
            field: 'title',
            html: true
          }
        ],
      }
    },
    created(){
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    mounted() {
      window.localStorage.setItem('real_time_control', '["messages","messages"]');
      var system = JSON.parse(window.localStorage.getItem('system'));
      if (system === null) {
        this.$router.push('/');
      }
      this.getMessages();
    },
    components:{
      GeneralSpinner
    },
    methods: {
      // Llegir tots els missatges del sistema
      getMessages() {
        axios.post(constants.ROOT_URL + '/api/v1/notifications/get_by_system')
          .then((response) => {
            console.log(response.data);
            this.messages = response.data;
            // Aqui posa al camp data la data+temps i al camp title el title+body, pk la taula nomes te 2 columnes
            for (var i = 0; i < this.messages.length; i++) {
              this.messages[i].date = this.messages[i].date + '<br>' + this.messages[i].time
              this.messages[i].title = '<b>' + this.messages[i].title + '</b> <br>' + this.messages[i].body
            }
            this.spinner_message=false;
          }, (response) => {
            console.log(response.data);
          });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Messages.vue?a9e9247e